<template>
	<div id="app" :class="'app page-' + activeRoute">
		<header>
			<c-main-nav></c-main-nav>
		</header>
		<main>
			<transition name="slide-fade-down" mode="out-in">
				<router-view></router-view>
			</transition>
		</main>
		<c-footer></c-footer>
	</div>
</template>

<script>
import CMainNav from '@/components/MainNav';
import CFooter from '@/components/Footer';

export default {
	name: 'app',
	components: {
		CMainNav,
		CFooter
	},
	watch: {
		'$route': function() {
			if (this.currentRoute.path.startsWith('/en')) {
				this.$store.dispatch('setCurrentLanguage', 'en-us');
			} else {
				this.$store.dispatch('setCurrentLanguage', 'de-ch');
			}
			this.$store.dispatch('loadACFOptionsPage')
			this.$store.dispatch('loadInitialPosts')
		}
	},
	beforeMount() {
		this.$store.dispatch('loadACFOptionsPage')
		this.$store.dispatch('loadInitialPosts')
	},
	created() {
		if (this.currentRoute.path.startsWith('/en')) {
			this.$store.dispatch('setCurrentLanguage', 'en-us');
		} else {
			this.$store.dispatch('setCurrentLanguage', 'de-ch');
		}
	},
	computed: {
		activeRoute: function() {
			return this.$route.name;
		},
		currentRoute() {
			return this.$store.state.route;
		}
	}
};
</script>



// WEBPACK FOOTER //
// App.vue?66d70fbc